
<div id="accordion-configuratore">
  <div class="card">
    <div class="card-header" id="titolo-veicolo">
      <a data-toggle="collapse"  (click)="stepOpen = stepOpen === 0 ? null : 0; setFormStep(0)">
          <p class="mb-0 font-weight-semi-bold panel-title">
          {{'VEICOLO' | translate | htmlToText}}
        </p>
        <p class="mb-0 small text-black text-uppercase" *ngIf="marcaSelected">
          {{marcaSelected.descrizione}}
        </p>
      </a>
    </div>

    <div class="collapse" [class.show]="stepOpen === 0">
      <div class="card-body">
        <form class="text-center">
          <div class="form-group text-left">
            <label for="marcaSelected" class="small mb-3">{{'SELEZIONA_MARCA_VEICOLO' | translate | htmlToText}}</label>
            <select class="form-control" name="marcaSelected" id="marcaSelected" [(ngModel)]="marcaSelected">
              <option [value]="undefined">{{'SELEZIONA' | translate | htmlToText}}</option>
              <option *ngFor="let marca of marcheVeicoloVisualizzate" [ngValue]="marca">{{marca.descrizione}}</option>
            </select>
          </div>
          <button type="button" class="btn btn-stem" (click)="nextStep()" [disabled]="!marcaSelected">{{ 'AVANTI' | translate | htmlToText }}</button>
        </form>
      </div>
    </div>
  </div>


  <div class="card">
    <div class="card-header" id="titolo-modello">
      <a data-toggle="collapse"  (click)="stepOpen = stepOpen === 1 ? null : 1; setFormStep(1)">
        <p class="mb-0 font-weight-semi-bold panel-title">
          {{'MODELLO_VEICOLO' | translate | htmlToText}}
        </p>
        <p class="mb-0 small text-black text-uppercase" *ngIf="modelloSelected">
          {{modelloSelected.descrizione}}
        </p>
      </a>
    </div>

    <div class="collapse" [class.show]="stepOpen === 1">
      <div class="card-body">
        <form class="text-center">
          <div class="form-group text-left">
            <label class="small mb-3">{{'SELEZIONA_MODELLO_VEICOLO' | translate | htmlToText}}</label>
            <select class="form-control" name="modelloSelected" [(ngModel)]="modelloSelected">
              <option [value]="undefined">{{'SELEZIONA' | translate | htmlToText}}</option>
              <option *ngFor="let modello of modelliVeicoloVisualizzati" [ngValue]="modello">{{modello.descrizione}}</option>
            </select>
          </div>
          <button type="button" class="btn btn-stem" [disabled]="stepAttivo < 1 && modelloSelected" (click)="nextStep()">{{ 'AVANTI' | translate | htmlToText }}</button>
        </form>
      </div>
    </div>
  </div>


  <div class="card">
    <div class="card-header" id="titolo-passo">
      <a data-toggle="collapse"  (click)="stepOpen = stepOpen === 2 ? null : 2; setFormStep(2)">
        <p class="mb-0 font-weight-semi-bold panel-title">
          {{'PASSO' | translate | htmlToText}}
        </p>
        <p class="mb-0 small text-black text-uppercase" *ngIf="passoSelected">
          {{passoSelected.codice}}
        </p>
      </a>
    </div>

    <div class="collapse" [class.show]="stepOpen === 2">
      <div class="card-body">
        <form class="text-center">
          <div class="form-group text-left">
            <label class="small mb-3">{{'SELEZIONA_PASSO_VEICOLO' | translate | htmlToText}}</label>
            <select class="form-control" name="passoSelected" [(ngModel)]="passoSelected">
              <option [value]="undefined">{{'SELEZIONA' | translate | htmlToText}}</option>
              <option *ngFor="let passo of passiVisualizzati" [ngValue]="passo">{{passo.codice}}</option>
            </select>
          </div>
          <button type="button" class="btn btn-stem" [disabled]="stepAttivo < 2 || !passoSelected" (click)="nextStep()">{{ 'AVANTI' | translate | htmlToText }}</button>
        </form>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header" id="titolo-trazione">
      <a data-toggle="collapse"  (click)="stepOpen = stepOpen === 3 ? null : 3; setFormStep(3)">
        <p class="mb-0 font-weight-semi-bold panel-title">
          {{'TRAZIONE' | translate | htmlToText }}
        </p>
        <p class="mb-0 small text-black text-uppercase" *ngIf="trazioneSelected">
          {{trazioneSelected.label | translate | htmlToText}}
        </p>
      </a>
    </div>

    <div class="collapse" [class.show]="stepOpen === 3">
      <div class="card-body">
        <form class="text-center">
          <div class="form-group text-left">
            <label class="small mb-3">{{'SELEZIONA_TRAZIONE_VEICOLO' | translate | htmlToText}}</label>
            <select class="form-control" name="trazioneSelected" [(ngModel)]="trazioneSelected">
              <option [value]="undefined">{{'SELEZIONA' | translate | htmlToText}}</option>
              <option *ngFor="let trazione of trazioniVisualizzate" [ngValue]="trazione">{{trazione.label | translate | htmlToText}}</option>
            </select>
          </div>
          <button type="button" class="btn btn-stem" [disabled]="stepAttivo < 3 || !trazioneSelected" (click)="nextStep()">{{ 'AVANTI' | translate | htmlToText }}</button>
        </form>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header" id="titolo-lato">
      <a data-toggle="collapse"  (click)="stepOpen = stepOpen === 4 ? null : 4; setFormStep(4)">
        <p class="mb-0 font-weight-semi-bold panel-title">
          {{'LATO_MONTAGGIO' | translate | htmlToText }}
        </p>
        <p class="mb-0 small text-black text-uppercase" *ngIf="latoSelected">
          {{ latoSelected | translate | htmlToText }}
        </p>
      </a>
    </div>

    <div class="collapse" [class.show]="stepOpen === 4">
      <div class="card-body">
        <form class="text-center">
          <div class="form-group text-left">
            <label class="small mb-3 text-left">{{'SELEZIONA_LATO_MONTAGGIO' | translate | htmlToText}}</label>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="radioTrazione" value="DX" [(ngModel)]="latoSelected" [checked]="latoSelected=='DX'" [attr.disabled]="latoDisabled('DX')">
              <label class="form-check-label small" for="destra">{{'DESTRA' | htmlToText | translate}}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="radioTrazione" value="SX" [(ngModel)]="latoSelected" [checked]="latoSelected=='SX'" [attr.disabled]="latoDisabled('SX')">
              <label class="form-check-label small" for="sinistra">{{'SINISTRA' | htmlToText | translate}}</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="radioTrazione" value="POST" [(ngModel)]="latoSelected" [checked]="latoSelected=='POST'" [attr.disabled]="latoDisabled('POST')">
              <label class="form-check-label small" for="posteriore">{{'POSTERIORE' | htmlToText | translate}}</label>
            </div>
          </div>
          <button type="button" class="btn btn-stem" [disabled]="stepAttivo < 4" (click)="nextStep()">{{ 'AVANTI' | translate | htmlToText }}</button>
        </form>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header" id="titolo-categoria-configuratore">
      <a data-toggle="collapse"  (click)="stepOpen = stepOpen === 5 ? null : 5; setFormStep(5)">
        <p class="mb-0 font-weight-semi-bold panel-title">
          {{'CATEGORIA_GRADINO' | translate | htmlToText}}
        </p>
        <p class="mb-0 small text-black text-uppercase" *ngIf="categorieSelectedLabel?.length > 0">
          <span *ngFor="let categoria of categorieSelectedLabel"> {{ categoria | translate | htmlToText}} &nbsp; <br></span>
        </p>
      </a>
    </div>

    <div class="collapse" [class.show]="stepOpen === 5">
      <div class="card-body">
        <form [formGroup]="formCategoria" class="text-center">
          <div class="form-group text-left">
            <label class="small mb-3 text-left">{{'SELEZIONA_CATEGORIE_GRADINO' | translate | htmlToText}}</label>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="Elettrico" formControlName="Elettrico" name="Elettrico" [checked]="isCategoriaSelected('Elettrico')">
              <label class="form-check-label small" for="elettrico">
                {{'ELETTRICO' | translate | htmlToText}}
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="Manuale" formControlName="Manuale" name="Manuale" [checked]="isCategoriaSelected('Manuale')">
              <label class="form-check-label small" for="manuale">
                {{'MANUALE' | translate | htmlToText}}
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="Meccanico" formControlName="Meccanico" name="Meccanico" [checked]="isCategoriaSelected('Meccanico')">
              <label class="form-check-label small" for="meccanico">
                {{'MECCANICO' | translate | htmlToText}}
              </label>
            </div>
          </div>
          <button type="button" class="btn btn-stem" [disabled]="stepAttivo < 5" (click)="nextStep()">{{ 'AVANTI' | translate | htmlToText }}</button>
        </form>
      </div>
    </div>
  </div>


</div>

